<div class="inline-flex items-center gap-1">
    <ng-content></ng-content>
</div>
